import { ThemeProvider } from "@fluentui/react";
import { initializeIcons } from "@fluentui/font-icons-mdl2";
import AppLayout from "./AppLayout";
import { ToastContainer } from "react-toastify";
import { ToastMessage } from "./Utils/UIMessages";
import "./App.scss";
import "./fluent-edit-css.scss";
import { useNavigate } from "react-router-dom";
import { AppRoutes } from "./Constants/AppRoutes";
import { refreshToken } from "./Utils/Generic";
// import { useSelector } from "react-redux";
// import { GlobalState } from "./Redux/RootReducer";
import { AppConfig } from "./Config";

const appTheme = {
  status: {
    danger: "blue",
  },
  palette: {
    // SSL Cloud: tavolozza verde del logo (#007038, titolare 01/11/2026); il rosso resta solo per allarmi ed errori
    themePrimary: '#007038',
    themeLighterAlt: '#eff8f3',
    themeLighter: '#c3e5d3',
    themeLight: '#95cfb0',
    themeTertiary: '#43a06d',
    themeSecondary: '#0d804a',
    themeDarkAlt: '#006532',
    themeDark: '#00552b',
    themeDarker: '#003f1f',
    neutralLighterAlt: '#faf9f8',
    neutralLighter: '#f3f2f1',
    neutralLight: '#edebe9',
    neutralQuaternaryAlt: '#e1dfdd',
    neutralQuaternary: '#d0d0d0',
    neutralTertiaryAlt: '#c8c6c4',
    neutralTertiary: '#b6b2af',
    neutralSecondary: '#9f9a96',
    neutralPrimaryAlt: '#87837e',
    neutralPrimary: '#292624',
    neutralDark: '#585450',
    black: '#403d39',
    white: '#ffffff',
  },
};

(window as any).generateAlarms = function (sentinelIds: number[]) {
  let alarms = [
    "data?lidarSx=10",
    "data?idarDx=10",
    "data?rumore=100",
    "data?pesogr=10",
    "data?door=1",
  ];
  sentinelIds.forEach((sentinelId) => {
    alarms.forEach((item, i) => {
      fetch(
        AppConfig.api.sentinelsUrl + "/" + sentinelId + "/" + item
      );
    });
  });
};

(window as any).sendDoorKeepalive = function (
  sentinelId: number,
  batteryLevel: number
) {
  fetch(
    AppConfig.api.sensorsUrl + "/doorsensor/keepalive?batteryLevel=" +
      batteryLevel +
      "&id=" +
      sentinelId
  );
};

initializeIcons();
(window as any)["ToastMessage"] = ToastMessage;
const App = () => {
  const navigate = useNavigate();
  const expiredSession = async () => {
    let sessionHasBeenRestored: "yes" | "no" | "wait" = await refreshToken();

    if (sessionHasBeenRestored === "no") {
      (window as any)["SessionExpired"] = true;
      // token scaduto e accesso automatico non riuscito: alla prossima apertura si parte dal login
      localStorage.removeItem("sessionToken");
      navigate(AppRoutes.APP_LOGIN_PAGE);
    } else if (sessionHasBeenRestored === "yes") {
      // Emetti evento per notificare che il token è stato rinnovato
      const event = new CustomEvent("token-refreshed");
      document.dispatchEvent(event);
      console.log("Token rinnovato con successo, evento emesso");
    }
  };
  (window as any)["expiredSession"] = expiredSession;
  return (
    <ThemeProvider theme={appTheme}>
      <ToastContainer />
      <AppLayout />
    </ThemeProvider>
  );
};

export default App;
